import { render, staticRenderFns } from "./MaxLengthTextarea.vue?vue&type=template&id=33fcf19e&scoped=true"
import script from "./MaxLengthTextarea.vue?vue&type=script&lang=js"
export * from "./MaxLengthTextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fcf19e",
  null
  
)

export default component.exports